import { Reveal } from "./Reveal";

const ITEMS = [
  { t: "Güven", d: "İnsanlar et satın almaz. Güvendikleri kasaptan alışveriş yaparlar." },
  { t: "İtibar", d: "Güven bir kez oluşmaz. Sürekli beslenir." },
  { t: "Sadakat", d: "Tek satış başarı değildir. Tekrar sipariş başarıdır." },
  { t: "Uzmanlık", d: "Kasaplık bilgi işidir. Uzmanlık görünür hale getirilmelidir." },
  { t: "Şeffaflık", d: "Müşteri görmediğinden korkar. Gösterilen süreç güven oluşturur." },
  { t: "Yakınlık", d: "Mahalle kasabı hissi. Samimiyet. Aile işletmesi sıcaklığı." },
];

export const BrandStrategy = () => (
  <section
    className="relative bg-[#050505] py-24 md:py-36 px-6 md:px-12 lg:px-24"
    data-testid="trust-strategy"
  >
    <Reveal className="max-w-3xl mb-16 md:mb-20">
      <span className="font-mono text-xs tracking-[0.3em] text-[#C48A5E] uppercase">
        02 — Stratejinin Temelleri
      </span>
      <h2 className="mt-5 font-serif text-4xl md:text-6xl text-[#F5F5F0]">
        Güven, <span className="italic text-[#C48A5E]">altı sütun</span> üzerinde durur.
      </h2>
    </Reveal>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {ITEMS.map((it, i) => (
        <Reveal key={it.t} delay={(i % 3) * 0.08}>
          <div className="group relative h-full rounded-2xl border border-white/5 bg-white/[0.02] backdrop-blur-2xl p-8 md:p-10 transition-all duration-500 hover:border-[#C48A5E]/40 hover:-translate-y-2">
            <span className="absolute top-6 right-7 font-mono text-xs text-[#A3A09A]/50">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="font-serif text-3xl md:text-4xl text-[#F5F5F0]">{it.t}</h3>
            <p className="mt-5 font-sans text-[15px] leading-relaxed text-[#A3A09A]">{it.d}</p>
            <div className="mt-8 h-px w-12 bg-[#C48A5E]/40 transition-all duration-500 group-hover:w-20" />
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default BrandStrategy;
